const i18n = {
  'en-US': {
    'login.form.title': 'Login to Tobiz Account',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.userName.placeholder': 'Username',
    'login.form.email.errMsg': 'Email cannot be empty',
    'login.form.email.formatErrMsg': 'Please enter a valid email address',
    'login.form.email.placeholder': 'Email',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.password.placeholder': 'Password',
    'login.form.login.errMsg': 'Login failed, please try again',
    'login.form.login.success': 'Login successful',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.rememberPassword': 'Remember password',
    'login.form.login': 'Login',
    'login.form.register': 'Create an account',
    'login.form.switchToOtp': 'Use OTP',
    'login.form.switchToPassword': 'Use Password',
    'login.form.otp.errMsg': 'OTP cannot be empty',
    'login.form.otp.placeholder': 'Enter OTP',
    'login.form.otp.send': 'Send OTP',
    'login.form.otp.send.again': 'Resend OTP',
    'login.form.otp.send.success': 'OTP sent successfully',
    'login.form.otp.send.fail': 'Failed to send OTP',
    'login.email.resend': 'Resend Verification Email',
    // 密码重置相关文本
    'reset.form.title': 'Reset Password',
    'reset.form.email.errMsg': 'Email cannot be empty',
    'reset.form.email.placeholder': 'Email',
    'reset.form.otp.errMsg': 'OTP cannot be empty',
    'reset.form.otp.placeholder': 'Enter OTP',
    'reset.form.otp.send': 'Send OTP',
    'reset.form.otp.send.again': 'Resend OTP',
    'reset.form.otp.send.success': 'OTP sent successfully',
    'reset.form.otp.send.fail': 'Failed to send OTP',
    'reset.form.password.errMsg': 'Password cannot be empty',
    'reset.form.password.placeholder': 'New Password',
    'reset.form.password_confirmation.errMsg': 'Please confirm your password',
    'reset.form.password_confirmation.placeholder': 'Confirm Password',
    'reset.form.password_confirmation.diff': 'The two passwords do not match',
    'reset.form.reset.errMsg': 'Reset failed, please try again',
    'reset.form.reset.success': 'Password reset successfully! Redirecting to login page...',
    'reset.form.reset.fail': 'Failed to reset password',
    'reset.form.reset': 'Reset Password',
    'reset.form.sendOtp': 'Send OTP',
    'reset.form.resetPassword': 'Reset Password',
    'reset.form.backToLogin': 'Back to Login'
  },
  'zh-CN': {
    'login.form.title': '登录 Tobiz Account',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.userName.placeholder': '用户名',
    'login.form.email.errMsg': '邮箱不能为空',
    'login.form.email.formatErrMsg': '请输入有效的邮箱地址',
    'login.form.email.placeholder': '邮箱',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.password.placeholder': '密码',
    'login.form.login.errMsg': '登录失败，请重新输入',
    'login.form.login.success': '登录成功',
    'login.form.forgetPassword': '忘记密码',
    'login.form.rememberPassword': '记住密码',
    'login.form.login': '登录',
    'login.form.register': '创建账户',
    'login.form.switchToOtp': '使用验证码',
    'login.form.switchToPassword': '使用密码',
    'login.form.otp.errMsg': '验证码不能为空',
    'login.form.otp.placeholder': '请输入验证码',
    'login.form.otp.send': '发送验证码',
    'login.form.otp.send.again': '重新发送',
    'login.form.otp.send.success': '验证码发送成功',
    'login.form.otp.send.fail': '验证码发送失败',
    'login.email.resend': '重新发送验证邮件',
    // 密码重置相关文本
    'reset.form.title': '重置密码',
    'reset.form.email.errMsg': '邮箱不能为空',
    'reset.form.email.placeholder': '邮箱',
    'reset.form.otp.errMsg': '验证码不能为空',
    'reset.form.otp.placeholder': '请输入验证码',
    'reset.form.otp.send': '发送验证码',
    'reset.form.otp.send.again': '重新发送',
    'reset.form.otp.send.success': '验证码发送成功',
    'reset.form.otp.send.fail': '验证码发送失败',
    'reset.form.password.errMsg': '密码不能为空',
    'reset.form.password.placeholder': '新密码',
    'reset.form.password_confirmation.errMsg': '请确认密码',
    'reset.form.password_confirmation.placeholder': '确认密码',
    'reset.form.password_confirmation.diff': '两次输入的密码不一致',
    'reset.form.reset.errMsg': '重置失败，请重试',
    'reset.form.reset.success': '密码重置成功！正在跳转到登录页面...',
    'reset.form.reset.fail': '密码重置失败',
    'reset.form.reset': '重置密码',
    'reset.form.sendOtp': '发送验证码',
    'reset.form.resetPassword': '重置密码',
    'reset.form.backToLogin': '返回登录'
  }
};
export default i18n;